import produce from 'immer';
import { actionTypes as dateRangePickerActionTypes, reducerValuesFunction as dateRangePickerReducerFunction } from '@components/Kendo/DateRangePickerReducer';
export const kitOrderActionTypes = Object.assign({ PAGE_CHANGED: 'KO_PAGE_CHANGED', SORT_CHANGED: 'KO_SORT_CHANGED', FILTER_CHANGED: 'KO_FILTER_CHANGED', FILTER_TOGGLED: 'KO_FILTER_TOGGLED', DATA_LOADED: 'KO_DATA_LOADED', SEARCH_CHANGED: 'KO_SEARCH_CHANGED' }, dateRangePickerActionTypes);
export const kitOrdersReducer = (state, action) => produce(state, (draft) => {
    var _a;
    if (Object.keys(dateRangePickerActionTypes).includes(action.type)) {
        dateRangePickerReducerFunction(draft, action);
        draft.page.skip = 0;
        return;
    }
    switch (action.type) {
        case kitOrderActionTypes.SEARCH_CHANGED:
            draft.search = (_a = action.search) !== null && _a !== void 0 ? _a : '';
            draft.page.skip = 0;
            break;
        case kitOrderActionTypes.DATA_LOADED:
            draft.data = action.data.data;
            draft.totalCount = action.data.totalCount;
            break;
        case kitOrderActionTypes.PAGE_CHANGED:
            if (action.page)
                draft.page = action.page;
            break;
        case kitOrderActionTypes.SORT_CHANGED:
            if (action.sort)
                draft.sort = action.sort;
            break;
        case kitOrderActionTypes.FILTER_CHANGED:
            if (action.filters) {
                draft.page.skip = 0;
                draft.filters = action.filters;
            }
            else if (action.field) {
                draft.page.skip = 0;
                draft.filters.values[action.field] = action.value;
            }
            break;
        case kitOrderActionTypes.FILTER_TOGGLED:
            if (action.field) {
                const key = action.field;
                draft.filters.active[key] = !draft.filters.active[key];
            }
            break;
    }
});
